import { render, staticRenderFns } from "./InputCoordinates.vue?vue&type=template&id=8a9740fe&scoped=true&"
import script from "./InputCoordinates.vue?vue&type=script&lang=js&"
export * from "./InputCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./InputCoordinates.vue?vue&type=style&index=0&id=8a9740fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9740fe",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VIcon,VRow,VSimpleTable,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a9740fe')) {
      api.createRecord('8a9740fe', component.options)
    } else {
      api.reload('8a9740fe', component.options)
    }
    module.hot.accept("./InputCoordinates.vue?vue&type=template&id=8a9740fe&scoped=true&", function () {
      api.rerender('8a9740fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputCoordinates.vue"
export default component.exports